import { Component, ViewEncapsulation } from '@angular/core';
import { ProjectSpecificationsComponent } from '../project-specifications/project-specifications.component';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';

/**
 * V2 version of Project Specifications component with collapsible header.
 * Extends the original component to reuse all business logic.
 *
 * CN-8312: Procurement Page UX Redesign
 */
@Component({
	selector: 'app-project-specifications-v2',
	templateUrl: './project-specifications-v2.component.html',
	styleUrls: [
		'../project-specifications/project-specifications.component.scss',
		'./project-specifications-v2.component.scss',
	],
	encapsulation: ViewEncapsulation.None,
})
export class ProjectSpecificationsV2Component extends ProjectSpecificationsComponent {

	// Collapsible header state - starts collapsed
	isHeaderCollapsed: boolean = true;

	// Toggle header collapse state
	toggleHeaderCollapse(): void {
		this.isHeaderCollapsed = !this.isHeaderCollapsed;
	}

	// Get summary lane text for collapsed header
	getSummaryLaneText(): string {
		const parts: string[] = [];

		if (IS_NOT_EMPTY(this.projectCopy?.originCity)) {
			parts.push(this.projectCopy.originCity);
		}

		if (IS_NOT_EMPTY(this.projectCopy?.originState)) {
			if (parts.length > 0) {
				parts[parts.length - 1] += ', ' + this.projectCopy.originState;
			} else {
				parts.push(this.projectCopy.originState);
			}
		}

		if (IS_NOT_EMPTY(this.projectCopy?.destCity) || IS_NOT_EMPTY(this.projectCopy?.destState)) {
			let dest = '';

			if (IS_NOT_EMPTY(this.projectCopy?.destCity)) {
				dest = this.projectCopy.destCity;
			}

			if (IS_NOT_EMPTY(this.projectCopy?.destState)) {
				dest += dest ? ', ' + this.projectCopy.destState : this.projectCopy.destState;
			}

			if (parts.length > 0) {
				return parts.join('') + ' → ' + dest;
			}

			return dest;
		}

		return parts.join('') || 'No lane';
	}

	// Get equipment abbreviation for collapsed header
	getEquipmentAbbreviation(): string {
		if (this.projectEquipments.length === 0) {
			return '';
		}

		return '(' + this.projectEquipments.map((equip) => equip[0]).join(',') + ')';
	}

	// Get assigned user name for collapsed header
	getAssignedUserName(): string {
		if (!this.projectCopy?.assigneeId) {
			return 'Unassigned';
		}

		// Full list: an assignee who is no longer ACTIVE is absent from usersList.
		const user = this.allUsersList?.find((u) => u.userId === this.projectCopy.assigneeId);
		return user?.name || 'Assigned';
	}
}
